/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
import { Select } from '@blueprintjs/select';
import { Button, Classes, MenuItem } from '@blueprintjs/core';
import { PropTypes } from 'prop-types';
import { filterItem, textItemRenderer, textItemStyles } from "./utils";
import { ColorAliases, Variables as VARIABLES } from 'styles/variables';

export const Dropdown = ({ activeItem, onSelectionChanged, options = [], label, buttonWidth="100%", ...rest }) => {
	const selectBtnCss = css`
		border: 1px solid #CED9E0;
		border-radius: 3px;
		display: flex;
		width: ${buttonWidth};
		justify-content: space-between;
		& .bp3-button-text {
			font-family: ${VARIABLES.PT_FONT_FAMILY};
			font-size: ${VARIABLES.PT_FONT_SIZE};
			color: ${ColorAliases.PT_ICON_COLOR};
			line-height: 18px;
		}
	`;

	return <Select
		items={options}
		itemPredicate={filterItem}
		itemRenderer={textItemRenderer(item => item)}
		noResults={<MenuItem disabled={true} text="No results." />}
		onItemSelect={onSelectionChanged}
		activeItem={activeItem}
		popoverProps={{ minimal: true }}
		{...rest}
	>
		<Button
			rightIcon="caret-down"
			minimal
			css={selectBtnCss}
			text={activeItem}
		/>
	</Select>
};

Dropdown.propTypes = {
	activeItem: PropTypes.string,
	label: PropTypes.any,
	onSelectionChanged: PropTypes.any,
	options: PropTypes.array,
};

